import React from 'react';

import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';

import SubMenuLeftColumn from 'components/navV2/navPrimarySubMenu/SubMenuLeftColumn';
import SubMenuColumn from 'components/navV2/navPrimarySubMenu/SubMenuColumn';
import NavMarketingModuleLarge from 'components/navV2/navPrimarySubMenu/NavMarketingModuleLarge';
import type { MegaMenuNavItem } from 'components/navV2/NavData/types';
import { primaryNavItemToBusinessUnitMap } from 'components/navV2/navPrimarySubMenu/helpers/mapPrimaryNavItemToBusinessUnit';

import css from '../subMenu.module.less';

export type NavPrimaryLargeModuleSubMenuProps = {
  activeNavType: PrimaryNavIdentifier.ALBUMS | PrimaryNavIdentifier.WEBSITE;
  data: MegaMenuNavItem;
};

const NavPrimaryLargeModuleSubMenu = ({
  activeNavType,
  data: { callToAction, title, children, id },
}: NavPrimaryLargeModuleSubMenuProps): JSX.Element => {
  const businessUnit = primaryNavItemToBusinessUnitMap[id];
  return (
    <>
      {callToAction ? (
        <SubMenuLeftColumn
          cta={callToAction}
          title={title}
          businessUnit={businessUnit}
          activeNavType={activeNavType}
        />
      ) : null}
      <NavMarketingModuleLarge activeNavType={activeNavType} businessUnit={businessUnit} />
      <div className={css.columnContainer}>
        {children.map((child, i) => {
          return (
            <SubMenuColumn
              headline={child.headline}
              links={child.children}
              borderLeft={child.borderLeft}
              twoColumns={child.twoColumns}
              key={i}
            />
          );
        })}
      </div>
    </>
  );
};

export default NavPrimaryLargeModuleSubMenu;
